import { render, staticRenderFns } from "./TagOperationItem.vue?vue&type=template&id=e960aee2&scoped=true&"
import script from "./TagOperationItem.vue?vue&type=script&lang=js&"
export * from "./TagOperationItem.vue?vue&type=script&lang=js&"
import style0 from "./TagOperationItem.vue?vue&type=style&index=0&id=e960aee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e960aee2",
  null
  
)

export default component.exports